<template>
  <b-card header="Company Pay Groups" header-tag="h4" body-class="mb-3 pb-0 record_card_body company_pay_groups">
    <div class="row">
      <div class="col-12 form-group">
        <h5><span class="bp_color">Listed below, the default payment time(s) for this company.</span>
          <span v-if="isPayrollCrm"><br>As well as when text notifications are sent to the workers who are due payment.</span></h5>
      </div>
      <div class="col-12" v-if="pay_groups.length > 0">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
            <tr>
              <th>Payment day</th>
              <th>Payment time</th>
              <th v-if="isPayrollCrm">Text day</th>
              <th v-if="isPayrollCrm">Text time</th>
              <th>Group created by</th>
              <th>Group created</th>
              <th>Remove</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="pay_group in pay_groups">
                <td>
                  <div class="td_data_outer">
                    <div class="td_data">{{pay_group.pay_group_day}}</div>
                  </div>
                </td>
                <td>
                  <div class="td_data_outer">
                    <div class="td_data">{{pay_group.pay_group_time}}</div>
                  </div>
                </td>
                <td v-if="isPayrollCrm">
                  <div class="td_data_outer">
                    <div class="td_data">{{pay_group.text_day}}</div>
                  </div>
                </td>
                <td v-if="isPayrollCrm">
                  <div class="td_data_outer">
                    <div class="td_data">{{pay_group.text_time}}</div>
                  </div>
                </td>
                <td>
                  <div class="td_data_outer">
                    <div class="td_data">{{return_pay_group_created_by(pay_group)}}</div>
                  </div>
                </td>
                <td>
                  <div class="td_data_outer">
                    <div class="td_data">{{return_pay_group_created_at(pay_group)}}</div>
                  </div>
                </td>
                <td>
                  <div class="td_data_outer">
                    <div class="td_data">
                      <button class="btn orcaBtn danger sm_btn" @click.prevent="delete_pay_group(pay_group)"><i class="fas fa-trash-alt"></i></button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 form-group text-right">
        <button class="btn orcaBtn sm_btn" @click.prevent="add_pay_groups">Add pay group</button>
      </div>
    </div>
    <modal_add_pay_groups v-if="$store.state.companies.pay_group_modal.show_modal"></modal_add_pay_groups>
  </b-card>
<!--
list pay groups for the client
order by day then time
-->
</template>

<script>
import modal_add_pay_groups from "partials/modals/companies/add_pay_group";
export default {
  name: "pay_groups",
  components: {
    modal_add_pay_groups
  },
  props: [
      'isPayrollCrm',
      'pay_groups',
      'company'
  ],
  methods: {
    return_pay_group_created_by(pay_group) {
      let created_by = pay_group.rel_company_logs.find(log => {
        return log.type === 'created'
      })
      if (created_by !== undefined) {
        return created_by.log_by.first_name + ' ' + created_by.log_by.surname
      }
      else return ""
    },
    return_pay_group_created_at(pay_group) {
      let created_by = pay_group.rel_company_logs.find(log => {
        return log.type === 'created'
      })
      if (created_by !== undefined) {
        return this.$options.filters.formatDateTime(created_by.created_at)
      }
      else return ""
    },
    delete_pay_group(pay_group) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm pay group deletion</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you want to delete the following pay group:<br><br>' +
            '<strong class="d-inline-block" style="width: 150px">Payment Day:</strong> ' + pay_group.pay_group_day + '<br>' +
            '<strong class="d-inline-block" style="width: 150px">Payment Time:</strong> ' + pay_group.pay_group_time + '<br>' +
            '<strong class="d-inline-block" style="width: 150px">Text Day:</strong> ' + pay_group.text_day + '<br>' +
            '<strong class="d-inline-block" style="width: 150px">Text Time:</strong> ' + pay_group.text_time  +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Delete', action: (toast) => {
              axios.delete(this.crmApiPath + 'company/pay_groups/' + pay_group.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                let changed_fields = [];
                changed_fields.push({
                  'field': 'pay_group',
                  'old_value': '',
                  'new_value': 'delete'
                });

                axios.post(this.crmApiPath + 'company/send_changed_email', {
                    title: 'PAY GROUP CHANGES',
                    company_id: pay_group.company_id,
                    changes: changed_fields,
                });

                this.$bus.$emit('company::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
                this.$snotify.remove(toast.id);
              })

            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id);
            }
          },
        ]
      });
    },
    add_pay_groups() {
      this.$store.commit('SHOW_ADD_PAY_GROUP_MODAL', {
        company_id: this.company.id,
        company_name: this.company.company_name
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_pay_group'));
    }
  }
}
</script>

<style lang="scss">
.company_pay_groups {
  .table {
    td {
      position:    relative;
      height:      45px;
      line-height: 15px;
      padding:     0 0.75rem;

      .td_data_outer {
        height:   45px;
        display:  block;
        width:    100%;
        position: relative;
      }

      .td_data {
        position:  absolute;
        top:       50%;
        transform: translateY(-50%);
        width:     100%;
      }
    }
  }
}
</style>
